// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"ea69e364","125":"2a2cee1c","142":"dcc7e9a0","186":"d2be5912","453":"be4a2963","751":"c8832cfb","768":"fd1e376e"}[chunkId] + ".chunk.js";
};